export const searchTypes = [
    {
        category: "Primary Key",
        type: "itemId",
        encrypted: false,
        semanticSearch: true
    },
    {
        category: "Numeric",
        type: "float",
        encrypted: true,
        semanticSearch: false
    },
    {
        category: "Numeric",
        type: "integer",
        encrypted: true,
        semanticSearch: false
    },
    {
        category: "Numeric",
        type: "long",
        encrypted: true,
        semanticSearch: false
    },
    {
        category: "String",
        type: "text",
        encrypted: true,
        semanticSearch: true
    },
    {
        category: "String",
        type: "keyword",
        encrypted: true,
        semanticSearch: true
    },

    {
        category: "Other",
        type: "boolean",
        encrypted: false,
        semanticSearch: false
    },

    {
        category: "Other",
        type: "datetime",
        encrypted: true,
        semanticSearch: false
    },

    {
        category: "Other",
        type: "date",
        encrypted: true,
        semanticSearch: false
    },

    // { type: "long", description: "Long number" },
    // { type: "double", description: "Double precision" },
    // { type: "binary", description: "Binary data" },
    // { type: "geoPoint", description: "Geo point" },
    // { type: "geoShape", description: "Geo shape" },
    // { type: "ip", description: "IP address" },
    // { type: "longKeyword", description: "Long keyword" },
    //
    // { type: "ipRange", description: "Range of IPs" },
    // { type: "integerRange", description: "Range of integers" },
    // { type: "longRange", description: "Range of long" },
    // { type: "floatRange", description: "Range of float" },
    // { type: "doubleRange", description: "Range of double" },
    // { type: "dateRange", description: "Range of dates" }
];


export const searchProps = {
    "itemId": { "type": "keyword" },
    "body": { "type": "text", "index": false },

    "float1": { "type": "float" },
    "float2": { "type": "float" },
    "float3": { "type": "float" },
    "float4": { "type": "float" },
    "float5": { "type": "float" },
    "float6": { "type": "float" },
    "float7": { "type": "float" },
    "float8": { "type": "float" },
    "float9": { "type": "float" },
    "float10": { "type": "float" },
    "float11": { "type": "float" },
    "float12": { "type": "float" },
    "float13": { "type": "float" },
    "float14": { "type": "float" },
    "float15": { "type": "float" },
    "float16": { "type": "float" },
    "float17": { "type": "float" },
    "float18": { "type": "float" },
    "float19": { "type": "float" },
    "float20": { "type": "float" },

    "integer1": { "type": "integer" },
    "integer2": { "type": "integer" },
    "integer3": { "type": "integer" },
    "integer4": { "type": "integer" },
    "integer5": { "type": "integer" },
    "integer6": { "type": "integer" },
    "integer7": { "type": "integer" },
    "integer8": { "type": "integer" },
    "integer9": { "type": "integer" },

    "long1": { "type": "long" },
    "long2": { "type": "long" },
    "long3": { "type": "long" },
    "long4": { "type": "long" },
    "long5": { "type": "long" },
    "long6": { "type": "long" },
    "long7": { "type": "long" },
    "long8": { "type": "long" },
    "long9": { "type": "long" },

    // Boolean
    "boolean1": { "type": "boolean" },
    "boolean2": { "type": "boolean" },
    "boolean3": { "type": "boolean" },
    "boolean4": { "type": "boolean" },
    "boolean5": { "type": "boolean" },
    "boolean6": { "type": "boolean" },
    "boolean7": { "type": "boolean" },
    "boolean8": { "type": "boolean" },
    "boolean9": { "type": "boolean" },

    "text1": { "type": "text", "index_options": "docs" },
    "text2": { "type": "text", "index_options": "docs" },
    "text3": { "type": "text", "index_options": "docs" },
    "text4": { "type": "text", "index_options": "docs" },
    "text5": { "type": "text", "index_options": "docs" },
    "text6": { "type": "text", "index_options": "docs" },
    "text7": { "type": "text", "index_options": "docs" },
    "text8": { "type": "text", "index_options": "docs" },
    "text9": { "type": "text", "index_options": "docs" },

    "keyword1": { "type": "keyword", "ignore_above": 65536 },
    "keyword2": { "type": "keyword", "ignore_above": 65536 },
    "keyword3": { "type": "keyword", "ignore_above": 65536 },
    "keyword4": { "type": "keyword", "ignore_above": 65536 },
    "keyword5": { "type": "keyword", "ignore_above": 65536 },
    "keyword6": { "type": "keyword", "ignore_above": 65536 },
    "keyword7": { "type": "keyword", "ignore_above": 65536 },
    "keyword8": { "type": "keyword", "ignore_above": 65536 },
    "keyword9": { "type": "keyword", "ignore_above": 65536 },

    //
    "date1": { "type": "date" },
    "date2": { "type": "date" },
    "date3": { "type": "date" },
    "date4": { "type": "date" },
    "date5": { "type": "date" },
    "date6": { "type": "date" },
    "date7": { "type": "date" },
    "date8": { "type": "date" },
    "date9": { "type": "date" },

    //
    "datetime1": { "type": "datetime" },
    "datetime2": { "type": "datetime" },
    "datetime3": { "type": "datetime" },
    "datetime4": { "type": "datetime" },
    "datetime5": { "type": "datetime" },
    "datetime6": { "type": "datetime" },
    "datetime7": { "type": "datetime" },
    "datetime8": { "type": "datetime" },
    "datetime9": { "type": "datetime" },
    //
    // "double1": { "type": "double" },
    // "double2": { "type": "double" },
    // "double3": { "type": "double" },
    // "double4": { "type": "double" },
    // "double5": { "type": "double" },
    // "double6": { "type": "double" },
    // "double7": { "type": "double" },
    // "double8": { "type": "double" },
    // "double9": { "type": "double" },
    //
    // "binary1": { "type": "binary" },
    // "binary2": { "type": "binary" },
    // "binary3": { "type": "binary" },
    //
    // "longKeyword1": { "type": "keyword", "ignore_above": 65536 },
    // "longKeyword2": { "type": "keyword", "ignore_above": 65536 },
    // "longKeyword3": { "type": "keyword", "ignore_above": 65536 },
    //
    // "geoPoint1": { "type": "geo_point" },
    // "geoPoint2": { "type": "geo_point" },
    // "geoPoint3": { "type": "geo_point" },
    //
    // "geoShape1": { "type": "geo_shape" },
    // "geoShape2": { "type": "geo_shape" },
    // "geoShape3": { "type": "geo_shape" },
    //
    // "ip1": { "type": "ip" },
    // "ip2": { "type": "ip" },
    // "ip3": { "type": "ip" },
    //
    // "integerRange1": { "type": "integer_range" },
    // "integerRange2": { "type": "integer_range" },
    // "integerRange3": { "type": "integer_range" },
    //
    // "longRange1": { "type": "long_range" },
    // "longRange2": { "type": "long_range" },
    // "longRange3": { "type": "long_range" },
    //
    // "floatRange1": { "type": "float_range" },
    // "floatRange2": { "type": "float_range" },
    // "floatRange3": { "type": "float_range" },
    //
    // "doubleRange1": { "type": "double_range" },
    // "doubleRange2": { "type": "double_range" },
    // "doubleRange3": { "type": "double_range" },
    //
    // "dateRange1": { "type": "date_range" },
    // "dateRange2": { "type": "date_range" },
    // "dateRange3": { "type": "date_range" },
    //
    // "ipRange1": { "type": "ip_range" },
    // "ipRange2": { "type": "ip_range" },
    // "ipRange3": { "type": "ip_range" }
}